function VideoPlayer(){

    console.log("VideoPlayer called");

    var self = this;

    self.$video = $("#video-player"); // video tag id

    self.videoPlayer("promo-video");

}

VideoPlayer.prototype.videoPlayer= function(id){

    console.log("my video player with ready");

    var self = this;

    var player = videojs(id,

        {

            "controls": false,
            "autoplay": false,
            "preload": "auto",
            "loop":true

        }/*, function() {


        this.on('ended', function() {

            console.log("video ended");

            player.play();

        });


    }*/);

    //var player = videojs('promo-video');



    player.ready(function() {
        console.log("video ready");

        this.play();
    });
    
};



